import { useSelector } from "react-redux";
import { type RootState } from "~/app/store";

export function useConfiguratorType() {
  return useSelector(selectConfiguratorType);
}

const selectConfiguratorType = (state: RootState) => state.linearConfigurator.type;

export function useConfiguratorProductCode() {
  return useSelector(selectConfiguratorProductCode);
}

const selectConfiguratorProductCode = (state: RootState) => state.linearConfigurator.productCode;
